import React, { useState } from "react";
import { Box, Button, Select, MenuItem, Snackbar, Alert, IconButton } from "@mui/material";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

const VideoControls = ({ onPlayPause, isPlaying, playbackRates, currentPlaybackRate, onPlaybackRateChange, onGoBack }) => {
  const [message] = useState("");
  const [showMessage, setShowMessage] = useState(false);

  return (
    <Box sx={{ 
      display: 'flex',
      alignItems: 'center',
      bgcolor: 'grey.800',
      p: 1,
      position: 'relative'
    }}>
      {/* Switch view mode button */}
     {/*  <Button 
        onClick={switchViewMode} 
        variant="contained" 
        color="primary" 
        sx={{ mx: 1, px: 2 }} 
        disabled={isPlaying}
      >
        Switch view
      </Button> */}
      <Button 
        onClick={onPlayPause} 
        variant="contained" 
        color="primary" 
        sx={{ mx: 0.5 }}
      >
        {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
      </Button>
      <Select
        value={currentPlaybackRate}
        onChange={(e) => onPlaybackRateChange(parseFloat(e.target.value))}
        size="small"
        sx={{ ml: 2, bgcolor: 'grey.700', color: 'white', minWidth: 80 }}
        MenuProps={{
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
          transformOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
          },
          PaperProps: {
            sx: {
              bgcolor: 'grey.700',
              '& .MuiMenuItem-root': {
                color: 'white',
                '&:hover': {
                  bgcolor: 'grey.600'
                },
                '&.Mui-selected': {
                  bgcolor: 'grey.800',
                  '&:hover': {
                    bgcolor: 'grey.800'
                  }
                }
              }
            }
          }
        }}
      >
        {playbackRates.map(rate => (
          <MenuItem key={rate} value={rate}>x{rate}</MenuItem>
        ))}
      </Select>
      
      <Box sx={{ flexGrow: 1 }} />
      <IconButton
        onClick={onGoBack}
        color="primary"
        sx={{ 
          color: 'white',
          bgcolor: 'rgba(0,0,0,0.5)',
          '&:hover': {
            bgcolor: 'rgba(0,0,0,0.7)'
          }
        }}
      >
        <ExitToAppIcon />
      </IconButton>
      
      <Snackbar
        open={showMessage}
        autoHideDuration={2000}
        onClose={() => setShowMessage(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="info" sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default VideoControls;
